import styled, { css } from 'styled-components';
import { Layout } from 'antd';

import theme from '@theme';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  div:last-child {
    border-right: none;
  }
`;

export const TimeWrapper = styled.div`
  height: 90px;
  width: 90px;
`;

export const StyledLayout = styled(Layout)`
  background-color: transparent;
`;

export const StyledContent = styled.div<{
  direction: boolean;
  alignVertical?: boolean;
}>`
  display: flex;
  flex-direction: ${({ direction }) => (direction ? 'column' : 'row')};

  ${({ alignVertical }) =>
    alignVertical &&
    css`
      flex-direction: column;
      gap: 12px;
    `}
`;

export const DateWrapper = styled.div<{ alignVertical?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  .is-bordered {
    border-right: 1px solid #000;
  }

  ${theme.mediaQueries.PHONE} {
    width: 100%;
    flex-direction: column;
    justify-content: flex-end;
    align-items: stretch;
    .is-bordered {
      border-right: none;
    }
  }

  ${({ alignVertical }) =>
    alignVertical &&
    css`
      flex-direction: column;
      gap: 12px;

      .is-bordered {
        border: 1px solid #000;
      }

      .car-rental-time-picker {
        width: 100%;

        & > div {
          width: 100%;
        }
      }
    `}
`;

export const CheckboxWrapper = styled.div`
  margin-bottom: 12px;
  .checkbox-desktop {
    margin-top: 12px;
  }
`;
